import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ShopBeaconComponent from './beacon.component';

const shopBeaconModule = angular.module('tinaba.components.shop.beacon', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('shop.beacon', {
      url: '/beacon',
      template: '<shop-beacon></shop-beacon>'
    });
})
.component('shopBeacon', ShopBeaconComponent);

export default shopBeaconModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/shop/beacon/beacon.js
 **/